export enum UserRole {
	Admin = "ADMIN",
	Agent = "AGENT",
	ThirdPartyEngineer = "THIRD_PARTY_INSTALLER_ENGINEER",
	SalesEngineer = "SALES_ENGINEER",
	BusinessDevelopmentPartner = "BUSINESS_DEVELOPMENT_PARTNER",
	PartnerTechnician = "PARTNER_TECHNICIAN"
}
